import { LoadingCard } from 'app/components/Table/loading/LoadingCard';
import Typography from 'app/components/Typography';

import { AlertsGroup } from 'app/modules/alerts/AlertsGroup';
import { EmptyAlert } from 'app/modules/alerts/components/EmptyAlert';
import { AlertType, TAB_ALERTS } from 'app/modules/alerts/core/type';
import useLoadMoreAlerts from 'app/modules/alerts/hooks/useLoadMoreAlerts';
import { AccordionWrapper, ButtonLoadMore } from 'app/modules/notifications/NotificationPage';

const DeviceConnection = ({ tab }: { tab: TAB_ALERTS }) => {
  const {
    isLoading,
    alertItems: rackFailedConnectionAlerts,
    hasMore,
    handleLoadMore,
    fetched,
  } = useLoadMoreAlerts({
    alertType: AlertType['Rack Failed Connection'],
  });

  return (
    <div
      className="d-flex flex-column position-relative overflow-auto"
      style={{ height: 'calc(100vh - 204px)', scrollBehavior: 'smooth' }}
    >
      {fetched && rackFailedConnectionAlerts.length > 0 ? (
        <AccordionWrapper>
          <div>
            <AlertsGroup
              index={0}
              key="Rack Failed Connection"
              type={AlertType['Rack Failed Connection']}
              alerts={rackFailedConnectionAlerts}
              tab={tab}
            />
          </div>

          {hasMore && (
            <div className="w-100 d-flex justify-content-center">
              <ButtonLoadMore onClick={handleLoadMore}>
                <Typography id="load-more-title" variant="title-4">
                  Load more
                </Typography>
              </ButtonLoadMore>
            </div>
          )}
        </AccordionWrapper>
      ) : fetched ? (
        <EmptyAlert />
      ) : null}

      {isLoading && <LoadingCard />}
    </div>
  );
};

export default DeviceConnection;
